<template>
  <van-collapse v-model="activeName" accordion>
    <van-collapse-item
      v-for="(item, index) in list"
      :name="index"
      :key="index"
      :title="item.goodsName"
    >
      <div class="content">
        <div class="list">
          <span class="list-left">原价</span>
          <span class="list-right">{{ item.oldPrice }}</span>
        </div>
        <div class="list">
          <span class="list-left">销售价</span>
          <span class="list-right">{{ item.singlePrice }}</span>
        </div>
        <div class="list">
          <span class="list-left">成团人数</span>
          <span class="list-right">{{ item.teamNumber }}</span>
        </div>
        <div class="list">
          <span class="list-left">当前库存</span>
          <span class="list-right">{{ item.goodsSurplusNumber }}</span>
        </div>
        <div class="list">
          <span class="list-left">销售量</span>
          <span class="list-right">{{ item.soldNumber }}</span>
        </div>
        <div class="list">
          <span class="list-left">状态</span>
          <span class="list-right">{{ item.statusExcel }}</span>
        </div>
      </div>
    </van-collapse-item>
  </van-collapse>
</template>

<script>
export default {
  props: {
    list: {
      type: Array,
      default() {
        return []
      }
    }
  },
  data() {
    return {
      activeName: [],
    };
  },
};
</script>
<style lang="stylus" scoped>
.content {
  .list {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    padding: 10px 0;
    color: #999999;
    font-size: 14px;
    .list-right {
      position relative
      display: flex;
      justify-content: flex-end;
      align-items: center;
      width: 230px;
      flex-wrap: wrap;
      color: #333333;
    }
  }
}
</style>
